
export class SpielerPerformance {
    constructor(spielerId, passNr, saison, team, timeFrame) {
        this.id = spielerId;
        this.info = { name: '', passNr: passNr, nationalitaet: '', verein: ''};
        this.lastgame = '';
        this.schnitt = {heim: 0, gast: 0};
        this.spieleHeim = [];
        this.spieleGast = [];
        this.team = team ? team.substr(team.indexOf(' / ')+3) : null;
        this.timeFrame = timeFrame;
        this.analysePerformance(saison);
    }

    analysePerformance(saison){
        console.log ("analysePerformance", saison);
        this.setHeimAndGastSpiele(saison);
    }
// getter
    countHeimSpiele(){
        return this.spieleHeim.length;
    }
    countGastSpiele(){
        return this.spieleGast.length;
    }
    countSpiele(){
        return this.countHeimSpiele() + this.countGastSpiele();
    }
    getKegel(type){
        let kegel = 0;
        let list = 'spiele' + type;
        this[list].forEach( (spiel) => {
            kegel += spiel.quote;
        });
        return kegel;
    }
    heimSchnitt(){
        return this.countHeimSpiele() > 0 ?
            (this.getKegel('Heim')/this.countHeimSpiele()).toFixed(2) : '-';
    }
    gastSchnitt(){
        return this.countGastSpiele() > 0 ?
            (this.getKegel('Gast')/this.countGastSpiele()).toFixed(2) : '-';
    }
    totalSchnitt(){
        const spiele = this.countGastSpiele() + this.countHeimSpiele();
        if ( spiele === 0 ) { return '-' }
        const kegel = this.getKegel('Heim') + this.getKegel('Gast');
        return (kegel/spiele).toFixed(2);
    }
// setter
    setHeimAndGastSpiele(saison){
        if ( this.timeFrame === 'H' || this.timeFrame === 'T' ) {
            this.setHeimAndGastSpieleSemester(saison, 'H');
        }
        if ( this.timeFrame === 'F' || this.timeFrame === 'T' ) {
            this.setHeimAndGastSpieleSemester(saison, 'F');
        }
    }
    setHeimAndGastSpieleSemester(saison, semester) {
        Object.keys(saison.local.spieleSchnittliste[semester].spiele).forEach( (spielId) => {
            const spiel = saison.local.spieleSchnittliste[semester].spiele[spielId];
            if ( !saison.showRound(spiel) ) { return; }
            if ( spiel.gast.spieler[this.id] &&
                 spiel.gast.spieler[this.id].name.substr(0,6) === this.info.passNr &&
                (!saison.local.showByTeam ||
                  saison.local.showByTeam && spiel.gast.teamName === this.team)) {
                this.setSpiel(  spiel.gast,
                                spiel.gast.spieler[this.id],
                                saison.spiele[spielId],
                                'spieleGast', spielId);
            } else if ( spiel.heim.spieler[this.id] &&
                        spiel.heim.spieler[this.id].name.substr(0,6) === this.info.passNr &&
                        (!saison.local.showByTeam ||
                          saison.local.showByTeam && spiel.heim.teamName === this.team)) {
                this.setSpiel(  spiel.heim,
                                spiel.heim.spieler[this.id],
                                saison.spiele[spielId],
                                'spieleHeim', spielId);
            }
        });
        this.spieleHeim.sort((b, a) => a.infos.sort > b.infos.sort ? 1 : -1);
        this.spieleGast.sort((b, a) => a.infos.sort > b.infos.sort ? 1 : -1);
        /*Object.keys(saison.spiele).forEach( (spielId) => {
            const partien = saison.spiele[spielId].partien;
            Object.keys(partien).forEach( (partieId) => {
                console.log ("partien[partieId].gast",partien[partieId].gast );
                if ( partien[partieId].gast.spieler.id === this.id ) {
                    this.setSpiel(partien[partieId], saison.spiele[spielId], 'spieleGast', partieId);
                } else if ( partien[partieId].heim.spieler.id === this.id ) {
                    this.setSpiel(partien[partieId], saison.spiele[spielId], 'spieleHeim', partieId);
                }
            });
        });*/
    }
        setSpiel(spielSchnittliste, spielerSpiel, spiel, targetList, spielId){
            let spielTemp = {
                quote: spielerSpiel.kegel,
                bahn: spielerSpiel.dg + ' / '+ spielerSpiel.bahn,
                punkte: [spielerSpiel.sp, spielerSpiel.mp],
                gegner: spielerSpiel.gegner,
                infos: {
                    runde: spiel.saison.runde + ' ' + spiel.saison.semester,
                    sort: spiel.saison.semester === 'H' ? 'A' + spiel.saison.runde : 'B' + spiel.saison.runde,
                    heimTeam: spiel.heim.teamName,
                    gastTeam: spiel.gast.teamName,
                },
                result: spiel.heim.result.mp + ':' + spiel.gast.result.mp,
                id: spielId,
            };
            this[targetList].push(spielTemp);
        // set spieler infos based on last spiel
            let spielTermin = spiel.infos.datum + spiel.infos.uhrzeit;
            if ( this.lastgame < spielTermin ) {
                this.setSpielerInfo(spielSchnittliste, spielerSpiel);
            }
        }
        /*setSpiel(partieData, spiel, targetList, partieId){
            const partieKeySpieler = targetList === 'spieleHeim' ? 'heim' : 'gast';
            const partieKeyGegner = partieKeySpieler === 'gast' ? 'heim' : 'gast';
            let spielTemp = {
                quote: partieData[partieKeySpieler].kegel,
                bahn: this.getDurchgang(partieId) + ' / '+ partieData[partieKeySpieler].bahn,
                punkte: [partieData[partieKeySpieler].sp, partieData[partieKeySpieler].mp],
                gegner: partieData[partieKeyGegner].spieler.name.substr(9) +
                        ' (' + partieData[partieKeyGegner].kegel + ')',
                partieSpieler: partieData[partieKeySpieler],
                partieGegner: partieData[partieKeyGegner],
                infos: {
                    runde: spiel.saison.runde + ' ' + spiel.saison.semester,
                    sort: spiel.saison.semester === 'H' ? 'A' + spiel.saison.runde : 'B' + spiel.saison.runde,
                    heimTeam: spiel.heim.teamName,
                    gastTeam: spiel.gast.teamName,
                },
                result: spiel.heim.result.mp + ':' + spiel.gast.result.mp,
            };
            this[targetList].push(spielTemp);
        // set spieler infos based on last spiel
            let spielTermin = spiel.infos.datum + spiel.infos.uhrzeit;
            let partieSpieler = partieData[partieKeySpieler].spieler;
            if ( partieSpieler && this.lastgame < spielTermin ) {
                this.setSpielerInfo(partieSpieler);
                this.info.verein = spiel[partieKeySpieler].vereinsNr + ' - ' +
                                   spiel[partieKeySpieler].vereinsName;
            }
        }*/

        setSpielerInfo(spielSchnittliste, spielerSpiel){
            this.info = { name: spielerSpiel.name.substr(9),
                          passNr: spielerSpiel.name.substr(0,6),
                          nationalitaet: spielerSpiel.land,
                          verein: spielSchnittliste.vereinsNr + ' / ' +
                                  spielSchnittliste.vereinsName
            };
            delete this.info.id;
        }

}